/* eslint-disable import/no-internal-modules */
import ConfirmationModal from '@insided/deprecated-preact-components/modal/ConfirmationModal'

interface Props {
  isOpen: boolean
  onClose: () => void
  onToggleSpam: () => void
  selectedReplyId?: string
}

const MarkAsSpamModal = (
  { isOpen, onClose, onToggleSpam, selectedReplyId }: Props) => {
  const bodyText = `The ${selectedReplyId === undefined ? 'topic' : 'post'} will not be visible in the community anymore, and the author will be banned.`
  return (
    <ConfirmationModal
      title='Mark as spam?'
      body={bodyText}
      action='Mark as spam and ban the author'
      variant='warning'
      isOpen={isOpen}
      onClose={onClose}
      handleConfirmation={onToggleSpam}
    />
  )
}

export default MarkAsSpamModal
